import {Component, OnInit, ViewChild, AfterViewInit, ViewChildren} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';

import Swal from 'sweetalert2/dist/sweetalert2.js'
import {
  MatSnackBar,

} from '@angular/material/snack-bar';

import {DatePipe} from '@angular/common';
import {MatStepper} from '@angular/material/stepper';
import {PDFfile} from './PDFfile';
import {environment} from '../../environments/environment';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TraslateService} from '../traslate.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {MatMenuTrigger} from '@angular/material/menu';

export interface PeriodicElementt {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}


export interface PeriodicElementfilter {
  name: string;
  position: number;
  weight: number;
  updated_at: Date;
  created_at: Date;
}

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss']
})
export class DeviceComponent implements OnInit {
  disableFiltreBydates = true
  dateSelected = ''
  checkbox: any
  manualPage: number = 0;
  pageSize1: any;
  pageSize = 10;
  lengthpage: number;
  pageNum: any;
  manualPage1: number;
  lengthTotal: any;
  currentPage = 0;
  totalSize = 0;
  devices;
  pageSizeOptions = [5, 10, 25, 100];
  public dateTime: Date
  index2: any = 10;
  dd: any = 0;
  pageSizeOptions1: number[];
  gg: any;
  itemSelect: any = [];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  itemSelect2: any;
  hiddenContenu: string = 'false';
  range: string;
  filterValue: string;
  repos: PeriodicElementt[];
  repos2: PeriodicElementfilter[];
  URL: RequestInfo;
  dataSourcet: any;
  refrech1: number = 2017;
  dt: any;
  days: any;
  finalDate: any;
  hiddenDetails: boolean = false;
  dtformt: string = "M/d/yyyy"
  // @ViewChild('stepper') stepper: MatStepper;
  // @ViewChild(MatMenuTrigger)
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  @ViewChild('secondPaginator', {static: true}) secondPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  jj: string;
  tblhidden: string;
  typeMessage: string;
  Id;
  ELEMENT_DATAFILTER: PeriodicElementfilter[]
  dataSource: any = null;
  getdt: string;
  rng: string;
  vehiculeList: any;
  IdCalibration: any;
  spinnerActive: boolean = false;
  spinnerActiveVehicule: boolean = false;
  url: string;
  device_id: any;
  is_online: any;
  dateMin = new Date(2009, 1, 2, 10, 30)
  dateMax = new Date()
  minDays: Number = 4;
  maxDays: Number = 7;
  device_name: any;
  rngUTC: string;
  spinnerActiveVehiculeTrameData: boolean = false;
  itemSelectresp: any = [];
  company_name: any;
  showdialog: boolean;
  rangeDate: string;

  ngOnInit(): void {
    this.spinnerActive = false

    this.hiddenContenu = 'true'

    // this.updateManualPage2(10);
    this.getUser()


  }

  resetDate() {
    (<HTMLInputElement>document.getElementById('dateTime')).value = ''
    this.rangeDate = ''
    this.getUserrefrech()
  }

  resetDataFromUnit() {
    (<HTMLInputElement>document.getElementById('dateTime')).value = ''
    this.rangeDate = ''
    this.dateSelected = ''
    this.disableFiltreBydates = true
    localStorage.removeItem('getdt')
    this.refrech()
    this.refrechvehiculedata();
    this.spinnerActive = true
    this.spinnerTrame.show();
    this.dataSource = new MatTableDataSource([]);
    this.devices = [];
    this.devices.length = 0;
    this.dataSource._updateChangeSubscription();
    this.paginator.pageIndex = 0;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this._snackBar.open('Les trames actualiser ', 'Fermer', {
      duration: 2500,

    });
    this.spinnerTrame.hide();
    this.spinnerActive = false


  }

  refrech() {
    (<HTMLInputElement>document.getElementById('getdt')).value = ''
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveVehicule = true
    this.spinnerTrame.show();
    this.http.get(environment.apiUrl + '/units', requestOptions).subscribe((response) => {

      this.vehiculeList = response;
      var list: any = this.vehiculeList.vehicles
      this.dataSourcet = new MatTableDataSource(list);
      this.dataSourcet.paginator = this.secondPaginator;
      this._snackBar.open('Les données des véhicules actualiser ', 'Fermer', {
        duration: 2500,
      });
      this.spinnerTrame.hide();
      this.spinnerActiveVehicule = false

    })
  }


  getNextData(currentSize, offset) {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActive = true;
    this.spinnerTrame.show();
    if (this.rangeDate) this.URL = environment.apiUrl + '/units/' + this.Id + "/trames/filter/" + this.rangeDate + '?page=' + offset;
    else this.URL = environment.apiUrl + '/units/' + this.Id + "/trames?page=" + offset;
    this.http.get(this.URL, requestOptions).subscribe((response: any) => {
      var list: any = response.data;
      list.length = response.total;
      this.devices.length = currentSize;
      this.devices.push(...list);
      this.dataSource = new MatTableDataSource([]);
      this.devices.length = response.total;
      this.dataSource = new MatTableDataSource(this.devices);
      this.dataSource._updateChangeSubscription();
      this.dataSource.paginator = this.paginator;
      this.spinnerTrame.hide();
      this.spinnerActive = false
    })
  }

  pageChanged(event) {
    let pageIndex = event.pageIndex;


    let pageSize = event.pageSize;

    let previousIndex = event.previousPageIndex;

    let previousSize = pageSize * pageIndex;

    this.getNextData(
      previousSize,
      (pageIndex + 1).toString()
    );
  }

  getDataModulesTramesSelected(idTrame, nom) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActiveVehiculeTrameData = true
    this.spinnerTrame.show();
    this.http.get(environment.apiUrl + '/trames/' + idTrame, requestOptions).subscribe((response) => {
      //console.log(document.body.scrollHeight)
      this.itemSelectresp = response
      this.dialog.open(nom, {
        // height:"900px",
        // width:"1000px",
        panelClass: 'first-Dialog'

      })

      window.scroll({
        top: 820,
        left: 0,
        behavior: 'smooth'
      });

      this.spinnerTrame.hide();
      this.spinnerActiveVehiculeTrameData = false
    })
  }

  openComunicaion(communication) {
    this.showdialog = true
    this.modif_communication();
    this.dialog.open(communication, {
      panelClass: 'my-Dialog'
    });
  }

  modif_communication() {
    this.registerForm.reset();
  }

  getUser() {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http.get(environment.apiUrl + '/units', requestOptions).subscribe((response) => {

      this.vehiculeList = response;
      //console.log(this.vehiculeList.vehicles);

      var list: any = this.vehiculeList.vehicles


      this.dataSourcet = new MatTableDataSource(list);
      this.dataSourcet.paginator = this.secondPaginator;

    })

  }

  getUserr(e) {
    this.disableFiltreBydates = false
    this.itemSelect = []
    this.Id = e;
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };


    this.getdt = (<HTMLInputElement>document.getElementById('getdt')).value
    this.IdCalibration = e
    localStorage.setItem('getdt', e);
    //console.log(localStorage.getItem('getdt'))
    this.spinnerActive = true
    this.spinnerTrame.show();
    if (this.rangeDate) {
      this.URL = environment.apiUrl + "/units/" + localStorage.getItem('getdt') + "/trames/filter/" + this.rangeDate
    } else {
      this.URL = environment.apiUrl + '/units/' + e + '/trames';
    }
    this.http.get(this.URL, requestOptions).subscribe((response: any) => {
      this.dataSource = new MatTableDataSource([]);
      // this.ELEMENT_DATAFILTER = JSON.stringify(response)
      var list: any = response.data;
      list.length = response.total;
      this.devices = list;
      this.devices.length = response.total;
      this.dataSource = new MatTableDataSource(this.devices);
      //console.log(this.dataSource)
      this.dataSource._updateChangeSubscription();
      this.paginator.pageIndex = 0;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerTrame.hide();
      this.spinnerActive = false

    })


  }

  refrechvehiculedata() {
    var id_vehicule = (<HTMLInputElement>document.getElementById('getdt')).value
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.URL = environment.apiUrl + "/units/" + id_vehicule
    this.http.get(this.URL, requestOptions).subscribe((response) => {
      //console.log(response)

      var unitResp: any = response
      this.itemSelect2 = unitResp.id;
      this.device_id = unitResp.device_id
      this.device_name = unitResp.name
      this.company_name = unitResp?.company
      this.is_online = unitResp.online
    })


  }

  getUserrefrech() {
    // this.refrechvehiculedata();
    // this.refrech();
    (<HTMLInputElement>document.getElementById('dateTime')).value = ''

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.getdt = (<HTMLInputElement>document.getElementById('getdt')).value

    localStorage.setItem('getdt', this.getdt);

    this.spinnerActive = true
    this.spinnerTrame.show();
    if (this.rangeDate) {
      this.URL = environment.apiUrl + "/units/" + localStorage.getItem('getdt') + "/trames/filter/" + this.rangeDate
    } else {
      this.URL = environment.apiUrl + '/units/' + localStorage.getItem('getdt') + '/trames';
    }
    this.http.get(this.URL, requestOptions).subscribe((response: any) => {

      this.dataSource = new MatTableDataSource([]);

      // this.ELEMENT_DATAFILTER = JSON.stringify(response)
      var list: any = response.data;
      this.devices = list;
      this.devices.length = response.total;
      this.dataSource = new MatTableDataSource(this.devices);
      this.dataSource._updateChangeSubscription();
      this.paginator.pageIndex = 0;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this._snackBar.open('Les trames actualiser ', 'Fermer', {
        duration: 2500,

      });
      this.spinnerTrame.hide();
      this.spinnerActive = false

    })

  }

  displayedColumnst: string[] = ['position'];

  displayedColumns: string[] = ['id', 'created_at', 'updated_at', 'unit_id', 'unitId', 'key', 'reason', 'sub_reason', 'trip_id', 'maneuver_id', 'timestamp', 'Longitude', 'Latitude', 'Satellites', 'Direction', 'Speed', 'data_brute'];
  // Assign the data to the data source for the table to render


  pipe: DatePipe;

  filterForm = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
  });

  get fromDate() {
    return this.filterForm.get('fromDate').value;
  }

  get toDate() {
    return this.filterForm.get('toDate').value;
  }

  rangeFormGroup = new FormGroup({
    start: new FormControl(),
    end: new FormControl()

  })
  rangeFormGroup2 = new FormGroup({
    dt10: new FormControl(),


  })


  constructor(private _snackBar: MatSnackBar, public dialog: MatDialog, private http: HttpClient, public traslateService: TraslateService, private spinnerTrame: NgxSpinnerService, private formBuilder: FormBuilder) {


  }

  openSnackBar() {
    this._snackBar.open('Cannonball!!', 'End now', {
      duration: 500,

    });
  }

  applyFilterr() {
    this.dataSource.filter = '' + Math.random();
  }


  async getRangeDateDevice() {
    this.rangeDate = ''
    this.dateSelected = ''
    this.range = (<HTMLInputElement>document.getElementById('dateTime')).value

    var firstD = this.range.split('~')[0].split('~')[0]

    //console.log(new Date(firstD).toISOString())
    var firstD2 = this.range.split('~')[1].split('~')[0]

    var date = new Date(); // Or the date you'd like converted.
    var isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
    this.rng = new Date(firstD) + "~" + new Date(firstD2)
    this.rngUTC = new Date(firstD).toISOString() + "~" + new Date(firstD2).toISOString()

    //console.log((new Date(firstD).toString()).substr(0, 24)+"~"+(new Date(firstD2).toString()).substr(0, 24))
    this.rangeDate = new Date(firstD).toString().substr(0, 21) + "~" + new Date(firstD2).toString().substr(0, 21)


    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL = environment.apiUrl + "/units/" + localStorage.getItem('getdt') + "/trames/filter/" + this.rangeDate


    var d = new Date();
    var n = d.getTimezoneOffset();

    this.spinnerActive = true
    this.spinnerTrame.show();

    this.http.get(this.URL, requestOptions).subscribe((response: any) => {

      this.itemSelect = []


      this.dataSource = new MatTableDataSource([]);

      // this.ELEMENT_DATAFILTER = JSON.stringify(response)
      var list: any = response.data

      this.devices = list;
      this.devices.length = response.total;
      this.dataSource = new MatTableDataSource(this.devices);
      this.dataSource._updateChangeSubscription();
      this.paginator.pageIndex = 0;
      this.dataSource.paginator = this.paginator;
      this.spinnerTrame.hide();
      this.spinnerActive = false

    })


    this._snackBar.open('Filtrage date effectuer: ' + this.rangeDate, 'Fermer', {
      duration: 2500,

    });


  }

  copyDataBrute(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.innerText = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this._snackBar.open(' Data brute copier ', 'Fermer', {
      duration: 1500,

    });
  }


  async FilterPeriode(RangeDate) {
    // switch (RangeDate) {
    //   case 1:
    //     this.dateSelected = '1 Jour'
    //     break;
    //   case 7:
    //     this.dateSelected = '7 jours'
    //     break;
    //   case 30:
    //     this.dateSelected = '1 mois'
    //     break;
    //   case 60:
    //     this.dateSelected = '2 mois'
    //     break;
    //   case 180:
    //     this.dateSelected = '6 mois'
    //     break;
    //   case 365:
    //     this.dateSelected = '1 année'
    //     break;
    //
    //
    // }

    (<HTMLInputElement>document.getElementById('dateTime')).value = ''
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.pipe = new DatePipe('en');
    this.days = this.pipe.transform(new Date(), 'M/d/yyyy');
    //console.log(this.days +new Date())

    var date = new Date();
    date.setDate(date.getDate() - RangeDate);

    this.finalDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    //console.log((new Date).toString().substr(0, 24) ,date.toString().substr(0, 24))
    var periodeFilter = date.toString().substr(0, 24) + ' ~ ' + (new Date).toString().substr(0, 24)
    this.rangeDate = date.toISOString() + "~" + (new Date).toISOString()
    this.URL = environment.apiUrl + "/units/" + localStorage.getItem('getdt') + "/trames/filter/" + this.rangeDate
    console.log('d', this.rangeDate)
    this.spinnerActive = true
    this.spinnerTrame.show();
    this.http.get(this.URL, requestOptions).subscribe((response: any) => {


      this.dataSource = new MatTableDataSource([]);

      // this.ELEMENT_DATAFILTER = JSON.stringify(response)
      var list: any = response.data
      this.devices = list;
      this.devices.length = response.total;
      this.dataSource = new MatTableDataSource(this.devices);
      this.dataSource._updateChangeSubscription();
      this.paginator.pageIndex = 0;
      this.dataSource.paginator = this.paginator;
      this.spinnerTrame.hide();
      this.spinnerActive = false
    })


    this._snackBar.open('Filtrage periode effectuer : ' + periodeFilter, 'Fermer', {
      duration: 2500,

    });
  }


  selectedRowIndex = -1;

  getItemDetails(e) {
    this.itemSelect = e;

    this.selectedRowIndex = e.id;
    this.hiddenDetails = true
  }

  selectedRowIndex2 = -1;

  getItemDetails2(e) {

    this.itemSelect2 = e.id;
    this.device_id = e.device_id
    this.device_name = e.name
    this.company_name = e?.company
    this.is_online = e.online


    this.selectedRowIndex2 = e.id;
    this.hiddenContenu = 'jkhjk';


  }


  gettbldetils() {
    this.tblhidden = 'true';
  }

  gettbldetilsd() {
    this.tblhidden = 'jjj';
  }

  // MatPaginator Output
  pageEvent: PageEvent;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions1 = setPageSizeOptionsInput.split(',').map(str => +str);

    }

  }


  public updateManualPage(index): void {

    this.pageNum = index
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length
    });


  }


  collection: any;

  public hiddencontenu() {
    this.hiddenContenu = 'true';
  }

  public hiddencontenu2() {
    this.hiddenContenu = 'jkhjk';
  }

  public updateManualPage2(index2): void {

    this.collection = []

    this.paginator.pageSize = index2

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length
    });


    this.lengthpage = parseInt("" + this.paginator.length / index2)


    //Create dummy data
    for (var i = 0; i < this.lengthpage + 1; i++) {
      this.collection.push(i + 1);
    }

  }


  exportDeviceTable(exportDirective, typeFile) {

    Swal.fire({
      title: 'Souhaitez-vous exporter la table type .' + typeFile + ' ?',
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Exporter Fichier !',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Export!',
          'Le fichier est exporté.'
        )
        //console.log(exportDirective);
        exportDirective.exportTable(typeFile, {
          fileName: 'STG_DRIVE_messages_entrants_date_' + new Date().toLocaleString(),
          sheet: 'STG DRIVE Messages Entrants',
          Props: {'Author': 'STG_DRIVE'}
        })
        /* var filename ='incoming message'

        const workSheet = XLSX.utils.json_to_sheet(this.dataSource.data, {header:["A","B","C","D","E","F",""], skipHeader:false});
        const workBook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
        XLSX.writeFile(workBook, filename+new Date()+'.xlsx'); */


        // For more information about handling dismissals please visit
        // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annuler',
          'Fichier non exporté !!'
        )
      }
    })

  }


  exportDeviceTablePDF() {

    Swal.fire({
      title: 'Souhaitez-vous exporter la table type PDF?',
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Exporter Fichier !',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {


        PDFfile.exportToPdf("ExampleTable", "tbl");

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Annuler',
          'Fichier non exporté !!'
        )
      }
    })

  }

  Device_Stepper_goBack(stepper: MatStepper) {

    stepper.previous();
  }

  Device_Stepper_goForward(stepper: MatStepper) {

    stepper.next();
  }


  applyFilter1(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcet.filter = filterValue2.trim().toLowerCase();

    if (this.dataSourcet.paginator) {
      this.dataSourcet.paginator.firstPage();

    }


    this.hiddenContenu = 'true'
  }

  applyFiltertest(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();


  }

  filter12() {
    //console.log(this.dataSource.data)
  }

  session() {
    this.jj = "kkkk"
    window.localStorage.setItem('j', 'kkkkk');


  }

  sessionget() {
    localStorage.setItem('email', 'abc@gmail.com');
    let mail = localStorage.getItem("email");
    if (mail) {
      //console.log('your email id is', mail);
    }
  }


  openDialogFileCommunication() {


    this.dialog.open(Device_communication, {

      data: {
        animal: 'panda'
      },
      width: '60%',
      height: '52%',
      panelClass: 'my-custom-dialog-class'
    });

    this.traslateService.urlCommunication.next(this.IdCalibration)
  }

  openDialogFileUpload() {
    this.dialog.open(Device_calibration, {
      data: {
        animal: 'panda'
      },
      width: '60%',
      height: '57%',
      autoFocus: false,
      panelClass: 'my-custom-dialog-class',

    });
    var id: any = 31
    this.traslateService.urlCalibration.next(this.IdCalibration)
  }

  command: any = 18;
  commandLine: any[] = [
    {value: 18, viewValue: 'DELETE UNSENT CSA EVENTS'},
    {value: 19, viewValue: 'Erase Accident Data'},
    {value: 17, viewValue: 'Request accident data upload'},
    {value: 56, viewValue: 'Restore vehicle preset'},
    {value: 20, viewValue: 'Calibration'}
  ];

  selectedCommand = this.commandLine[0].value;

  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    commandType: [, {validators: [Validators.required], updateOn: "change"}],
    action: [],


  });

  getValueSelect(e) {
    this.command = e
    //console.log(e)

  }

  submitFormCommunication() {
    //console.log(this.IdCalibration)

    //console.log(this.registerForm.value)

    this.http.post(environment.apiUrl + '/units/' + this.IdCalibration + '/command', this.registerForm.value).subscribe(resp => {
      //console.log(environment.apiUrl+'/units/'+ this.IdCalibration+'/command')
      var statusNumber: any = resp

      if (statusNumber.status == 200) {
        Swal.fire({
          position: 'center',
          title: statusNumber.message,
          showConfirmButton: false,
          timer: 4000
        })
        this.getUserrefrech()
      } else if (statusNumber.status == 500) {

        Swal.fire({
          text: statusNumber.message.join('<br>'),

        })
      }

    })


  }
}


/*Historique de calibration*/

@Component({
  selector: 'device_calibration',
  styleUrls: ['./device.component.scss'],
  templateUrl: 'device_calibration.html',
})
export class Device_calibration implements AfterViewInit {
  url: any;
  calibration: any;
  Calibration_DataSource: any;

  constructor(public traslateService: TraslateService, private http: HttpClient, private spinnerCalibration: NgxSpinnerService) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.traslateService.currentdataCalibration.subscribe(data => {
      this.url = data

      this.spinnerCalibration.show();
      this.http.get(environment.apiUrl + '/units/' + this.url + '/calibrations', requestOptions).subscribe((response) => {

        var listCalibration: any = response
        this.calibration = listCalibration.calibrations

        this.Calibration_DataSource = new MatTableDataSource(this.calibration);
        this.Calibration_DataSource.sort = this.sort;
        this.spinnerCalibration.hide();
      })
    })


  }


  Calibration_DisplayedColumns = ['timestamp', 'calibration'];


  @ViewChild(MatSort) sort: MatSort;

  ngAfterViewInit() {

  }
}

export interface Device_calibrationElement {
  Date: any;
  Statut_calibration: any;
  Details: any;

}


/*communication boitier*/

@Component({
  selector: 'device_communication',
  styleUrls: ['./device.component.scss'],
  templateUrl: 'device_communication.html',
})
export class Device_communication implements AfterViewInit {
  command: any = 18;
  url: string;

  constructor(public traslateService: TraslateService, private http: HttpClient, public dialogRef: MatDialogRef<Device_communication>, private formBuilder: FormBuilder) {


  }

  checked = false;
  commandLine: any[] = [
    {value: 18, viewValue: 'DELETE UNSENT CSA EVENTS'},
    {value: 19, viewValue: 'Erase Accident Data'},
    {value: 17, viewValue: 'Request accident data upload'},
    {value: 56, viewValue: 'Restore vehicle preset'},
    {value: 20, viewValue: 'Calibration'}
  ];

  selectedFood = this.commandLine[0].value;

  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    commandType: [, {validators: [Validators.required], updateOn: "change"}],
    action: [],


  });

  getValueSelect(e) {
    this.command = e


  }

  ngAfterViewInit(): void {
    this.traslateService.currentdataCommunication.subscribe(data => {
      this.url = data
    })
  }

  onNoClick(): void {
    this.dialogRef.close();

  }

  submitFormCommunication() {


    this.http.post(environment.apiUrl + '/units/' + this.url + '/command', this.registerForm.value).subscribe(resp => {

      var statusNumber: any = resp


      if (statusNumber.status == 200) {
        Swal.fire({
          position: 'center',
          title: statusNumber.response + '!',
          showConfirmButton: false,
          timer: 5000
        })

      } else {

        Swal.fire({
          text: statusNumber.response.join('<br>'),

        })
      }

    })


  }

}
